import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JsonUtilsService {
  baseUrl: string = environment.BaseURL;
  constructor() { }

  generatePageHTML(paragraphs) {
    if (!paragraphs || !Array.isArray(paragraphs)) {
      return;
    }

    return paragraphs.map(paragraph => {
      const type = paragraph.type?.toLowerCase().trim();
      const styleAttr = paragraph.cssStyle ? ` style="${paragraph.cssStyle}"` : '';

      if (!paragraph.text && !['image', 'fieldset', 'table', 'list'].includes(type)) {
        return '';
      }

      switch (type) {
        case 'image':
          return this.generateImageHTML(paragraph);
        case 'heading':
          return this.generateHeadingHTML(paragraph, styleAttr);
        case 'text':
        case 'paragraph':
        case 'pre':
          return this.generateTextHTML(paragraph, styleAttr);
        case 'bulletpoints':
          return this.generateBulletPointsHTML(paragraph, styleAttr);
        case 'list':
          return this.generateListHTML(paragraph, styleAttr);
        case 'table':
          return this.generateTableHTML(paragraph, styleAttr);
        case 'formfield':
          return this.generateFormFieldHTML(paragraph, styleAttr);
        case 'fieldset':
          return this.generateFieldsetHTML(paragraph, styleAttr);
        default:
          return `<p${styleAttr}>${paragraph.text}</p>`;
      }
    }).join('\n');
  }

  // Function for Image
  generateImageHTML(paragraph) {
    if (!paragraph.image?.url) return '';
    var wrapperStyle = paragraph?.cssStyle || `margin-left: auto; margin-right: auto; overflow:hidden; text-align:center`;
    var imgStyle = paragraph.image?.cssStyle || `overflow:hidden;max-width:100%;`;
    var captionStyle = paragraph.image?.captionStyle || `font-style:italic;font-size:11px;text-align:center;margin-top:5px;max-width: 100%;margin-bottom:10px`;
    if (imgStyle && imgStyle.indexOf("flex") >= 0) {
      // reset old style wrongly saved
      imgStyle = null;
    }
    let imageHtml = `<div style="${wrapperStyle}" class="${paragraph.heroImage ? 't-image t-key-hero' : 't-image'}">
      <img src="${this.baseUrl}${paragraph.image.url}" alt="${paragraph.text || ''}" style="${imgStyle}" />`;

    let isDefaultAltText = !paragraph.image?.altText || paragraph.image?.altText.trim() === '' || paragraph.image?.altText === '&nbsp;';
    let altText = isDefaultAltText ? 'Enter caption here' : this.formatText(paragraph.image.altText);
    imageHtml += `<div class="alt-text t-alt-text ${isDefaultAltText ? 'd-none' : ''}" style="${captionStyle}">
        ${altText}
    </div>
    </div>`;

    return imageHtml;
  }

  generateHeadingHTML(paragraph, styleAttr) {
    const headingTag = paragraph.htmlTag?.match(/h[1-6]/i)?.[0]?.toLowerCase() || 'h4';
    return `<${headingTag}${styleAttr}>${this.formatText(paragraph.text)}</${headingTag}>`;
  }

 
  generateTextHTML(paragraph, styleAttr) {
    const type = paragraph.type?.toLowerCase().trim();
    if (type === 'pre') {
      return `<pre${styleAttr}>${paragraph.text}</pre>`;
    } else {
      return `<p${styleAttr}>${paragraph.text}</p>`;
    }
  }

  // Function for Bullet Points
  generateBulletPointsHTML(paragraph, styleAttr) {
    const bullets = paragraph.text.split('\n').filter(point => point.trim());
    return `<ul${styleAttr}>${bullets.map(point => `<li>${point.trim()}</li>`).join('')}</ul>`;
  }

  // Function for List
  generateListHTML(paragraph, styleAttr) {
    if (!paragraph.items) return '';
    return `<ul${styleAttr}>${paragraph.items.map(point => `<li>${point.trim()}</li>`).join('')}</ul>`;
  }

  // Function for Table
  generateTableHTML(paragraph, styleAttr) {
    if (!paragraph.table) return '';
    const tableHTML = [`<div><table${styleAttr}>`];
    if (paragraph.table.header) {
      tableHTML.push('<thead><tr>');
      paragraph.table.header.cells.forEach(cell => {
        tableHTML.push(`<th>${this.formatText(cell.text)}</th>`);
      });
      tableHTML.push('</tr></thead>');
    }
    if (paragraph.table.rows) {
      tableHTML.push('<tbody>');
      paragraph.table.rows.forEach(row => {
        tableHTML.push('<tr>');
        row.cells?.forEach(cell => {
          tableHTML.push(`<td>${this.formatText(cell.text)}</td>`);
        });
        tableHTML.push('</tr>');
      });
      tableHTML.push('</tbody>');
    }
    tableHTML.push('</table></div>');
    return tableHTML.join('\n');
  }

  // Function for Form Field
  generateFormFieldHTML(paragraph, styleAttr) {
    if (!paragraph.field) return '';
    return `<div><table class="form-table"${styleAttr}><tbody>
      <tr><td class="label">${this.formatLabel(paragraph.field.name)}</td>
      <td class="value">${this.formatText(paragraph.field.value || '')}</td></tr></tbody></table></div>`;
  }

  // Function for Fieldset
  generateFieldsetHTML(paragraph, styleAttr) {
    if (!paragraph.fieldSet?.fields?.length) return '';
    const rows = paragraph.fieldSet.fields.map(field => {
      return `<tr><td class="label">${this.formatLabel(field.name)}</td>
        <td class="value">${this.formatText(field.value || '')}</td></tr>`;
    }).join('\n');
    return `<div><table class="form-table"${styleAttr}><tbody>${rows}</tbody></table></div>`;
  }

  formatText(text) {
    if (!text) return '';
    return text.replace(/(\r\n|\n)/g, '<br/>');
  }

  formatLabel(text) {
    if (!text) return '';
    text = text.trim();
    return text.endsWith(':') ? text : `${text}:`;
  }
}
